<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{path: '/orders/orderList'}">{{ $t('common.home') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('fund.fundDetail') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row" style="padding: 0px">
          <el-col :span="isClientManage === '1' ? 6 : 8" class="display-row">
            <div class="query-title">{{ $t('fund.tradeStartDate') }}:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.createTimeStart" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" :placeholder="$t('common.selectDate')"></el-date-picker>
            </div>
          </el-col>
          <el-col :span="isClientManage === '1' ? 6 : 8" class="display-row">
            <div class="query-title">{{ $t('fund.tradeEndDate') }}:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.createTimeEnd" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" :placeholder="$t('common.selectDate')"></el-date-picker>
            </div>
          </el-col>
          <el-col :span="isClientManage === '1' ? 6 : 8" class="display-row">
            <div class="query-title" style="text-align: right">{{ $t('fund.tradeNo') }}:</div>
            <div class="flex1">
              <el-input :placeholder="$t('common.pleaseInput')" clearable v-model="queryInfo.tradingNo" size="small"
                @keyup.enter.native="searchList"></el-input>
            </div>
          </el-col>
          <el-col v-if="isClientManage === '1'" :span="6" class="display-row">
            <div class="query-title2">{{ $t("cnumber.cnumber20") }}:</div>
            <div class="flex1">
              <ChildCode v-model="queryInfo.customerUserId"></ChildCode>
            </div>
          </el-col>
        </el-row>
        <el-row class="search-row" style="padding: 0px;margin-top: 10px;">
          <el-col :span="24" class="display-row">
            <div style="text-align: right; width: 100%; padding-right: 10px; floate: right">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">{{ $t('common.reset') }}</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">{{ $t('common.search') }}</el-button>
              <el-button class="search-btn btn-blue" @click="exportCapitalRecordList">{{ $t("export") }}</el-button>
              <el-button class="search-btn btn-green" @click="toRecharge">{{ $t('fund.recharge') }}</el-button>
              <el-button class="search-btn btn-green" @click="toRechargeList">{{ $t('fund.rechargeLog') }}</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" :data="recordList" border stripe
          height="550" :row-style="{height: '40px'}">
          <el-table-column type="index" align="center" :label="$t('wzbg.wz6')" width="60"></el-table-column>
          <el-table-column prop="tradingNo" align="center" :label="$t('fund.tradeNo')"></el-table-column>
          <el-table-column prop="orderNo" align="center" :label="$t('fund.relationOrderNo')"></el-table-column>
          <el-table-column prop="userName" align="center" :label="$t('createOrder.createOrder102')">
            <template v-slot="scope">
              {{ scope.row.userName }}
            </template>
          </el-table-column>
          <el-table-column prop="clientManagerUserName" align="center" :label="$t('cnumber.cnumber30')">
            <template v-slot="scope">
              {{ scope.row.clientManagerUserName }}
            </template>
          </el-table-column>
          <el-table-column prop="dealDesc" align="center" :label="$t('fund.tradeIntro')"></el-table-column>
          <el-table-column prop="createTime" sortable align="center" :index="indexMethod" :label="$t('fund.tradeTime')">
            <template v-slot="scope">
              {{ scope.row.createTime | dateFormatToSecond }}
            </template>
          </el-table-column>
          <el-table-column prop="typeDetail" sortable align="center" :index="indexMethod" :label="$t('fund.tradeType')">
            <template v-slot="scope">
              {{ typeDetailShow(scope.row.typeDetail) }}
            </template>
          </el-table-column>
          <el-table-column prop="money" sortable align="center" :index="indexMethod" :label="$t('fund.amount')">
            <template v-slot="scope">
              {{ moneyShow(scope.row.moneyFlag, scope.row.money) }}
            </template>
          </el-table-column>
          <el-table-column prop="balance" sortable align="center" :index="indexMethod" :label="$t('fund.balance')">
            <template v-slot="scope">
              {{ scope.row.balance || scope.row.balance === 0 ? formatThousands(scope.row.balance) : '' }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]" :pager-count="5" :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </table-con>
  </div>
</template>

<script>
import tableCon from '../../views/tableContainer';
import ChildCode from "@/components/ChildCode/index.vue";
import { formatThousands } from "@/assets/js/utils";

export default {
  components: {ChildCode, tableCon },
  data () {
    return {
      formatThousands,
      isClientManage: this.$store.state.isClientManage,
      queryInfo: {
        customerUserId: '',
        tradingNo: '',
        createTimeStart: '',
        createTimeEnd: '',
        pageSize: 10,
        pageNum: 1,
      },
      orderDateRangeValue: [],
      recordList: [],
      total: 0,
    };
  },
  methods: {
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.getrecordList();
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.getrecordList();
    },
    orderDateRange () { },
    toRecharge () {
      this.$router.push({
        name: 'recharge',
      });
    },
    toRechargeList () {
      this.$router.push({
        name: 'RechargeList',
      });
    },
    searchList () {
      //查询
      this.queryInfo.pageNum = 1;
      this.getrecordList();
    },
    async getrecordList () {
      console.log(this.queryInfo);
      const { data: res } = await this.$http.get('cmUser/capitalRecord/list', { params: this.queryInfo });
      console.log(res);
      this.recordList = res.data.list;
      this.total = res.data.total;
    },
    async exportCapitalRecordList () {
      this.$http({
        url: 'cmUser/capitalRecord/exportCapitalRecordList',
        method: 'get',
        params: this.queryInfo,
        responseType: 'blob', // 表明返回服务器返回的数据类型
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          //接口参数
        }
      }).then((res) => {
        //创建一个隐藏的a连接，
        const link = document.createElement('a');
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        //设置连接
        link.href = URL.createObjectURL(blob);
        link.download = '资金明细.xlsx';
        document.body.appendChild(link);
        //模拟点击事件
        link.click();
      }).catch((err) => {
        // console.log(err);
      })
    },
    queryInfoClear () {
      //清空
      this.queryInfo = {
        createTimeStart: '',
        createTimeEnd: '',
        tradingNo: '',
        pageSize: 10,
        pageNum: 1,
      };
      this.orderDateRangeValue = [];
    },
    typeDetailShow (status) {
      switch (status) {
        case '1':
          return this.$t('fund.recharge');
        case '2':
          return this.$t('fund.fund7');
        case '2+':
          return this.$t('fund.fund13');
        case '3':
          return this.$t('fund.payOrder');
        case '4':
          return this.$t('fund.compensate');
        case '5':
          return this.$t('fund.deduct');
        case '6':
          return this.$t('fund.withdrawal');
        case '7':
          return this.$t('fund.fund1');
        case '8':
          return this.$t('fund.fund2');
        case '9':
          return this.$t('fund.fund3');
        case '10':
          return this.$t('fund.fund7');
        case '11':
          return this.$t('fund.fund5');
        case '12':
          return this.$t('fund.fund6');
        case '13':
          return this.$t('fund.fund8');
        case '14':
          return this.$t('fund.fund9');
        case '15':
          return this.$t('fund.fund10');
        case '16':
          return this.$t('fund.fund12');
        case '16+':
          return this.$t('fund.fund11');
      }
    },
    moneyShow (moneyFlag, money) {
      switch (moneyFlag) {
        case '1':
          return '+' + formatThousands(money);
        case '0':
          return '-' + formatThousands(money);
      }
    },
  },
  watch: {
    //监听时间选择器绑定值变化
    orderDateRangeValue () {
      //解决时间选择器清空后 绑定值为null问题
      if (!this.orderDateRangeValue) {
        this.orderDateRangeValue = [];
        this.queryInfo.createTimeStart = '';
        this.queryInfo.createTimeEnd = '';
      } else {
        if (this.orderDateRangeValue.length > 0) {
          this.queryInfo.createTimeStart = this.orderDateRangeValue[0];
          this.queryInfo.createTimeEnd = this.orderDateRangeValue[1];
        }
      }
    },
  },
  created () {
    this.getrecordList();
  },
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}

.el-table .el-button--small {
  padding: 4px 10px;
}
.query-title {
  width: 100px;
}
.query-title2 {
  width: 120px;
  text-align: right;
  margin-top: 5px;
  margin-right: 5px;
}
.search-btn {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
</style>
